/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sample: NonNullable<unknown> }} Measure_Latency_Title_SampleInputs */

const en_measure_latency_title_sample = /** @type {(inputs: Measure_Latency_Title_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Response time (${i?.sample})`)
};

const zh_hans1_measure_latency_title_sample = /** @type {(inputs: Measure_Latency_Title_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`响应时间（${i?.sample}）`)
};

const pt_br2_measure_latency_title_sample = /** @type {(inputs: Measure_Latency_Title_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempo de resposta (${i?.sample})`)
};

const es_measure_latency_title_sample = /** @type {(inputs: Measure_Latency_Title_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiempo de respuesta (${i?.sample})`)
};

const fr_measure_latency_title_sample = /** @type {(inputs: Measure_Latency_Title_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temps de réponse (${i?.sample})`)
};

const de_measure_latency_title_sample = /** @type {(inputs: Measure_Latency_Title_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Antwortzeit (${i?.sample})`)
};

const ru_measure_latency_title_sample = /** @type {(inputs: Measure_Latency_Title_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Время ответа (${i?.sample})`)
};

const it_measure_latency_title_sample = /** @type {(inputs: Measure_Latency_Title_SampleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempo di risposta (${i?.sample})`)
};

/**
* | output |
* | --- |
* | "Response time ({sample})" |
*
* @param {Measure_Latency_Title_SampleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_title_sample = /** @type {((inputs: Measure_Latency_Title_SampleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_Title_SampleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_title_sample(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_title_sample(inputs)
	if (locale === "es") return es_measure_latency_title_sample(inputs)
	if (locale === "fr") return fr_measure_latency_title_sample(inputs)
	if (locale === "de") return de_measure_latency_title_sample(inputs)
	if (locale === "ru") return ru_measure_latency_title_sample(inputs)
	if (locale === "it") return it_measure_latency_title_sample(inputs)
	return en_measure_latency_title_sample(inputs)
});